import React from 'react';

import UserHeaderLoggedInDropdown from 'dpl/components/Header/UserHeaderLoggedInDropdown';
import useNotificationCounts from 'dpl/shared/hooks/useNotificationCounts';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';

import StripeChargeLoginButton from '../StripeChargeLoginButton';

export default function StripeChargeUserHeaderMenu() {
  const currentUser = useCurrentUser();
  const notificationCounts = useNotificationCounts();

  const handleSuccessfulLogin = async () => {
    await currentUser.fetch();
    window.location.reload();
  };

  if (currentUser.isLoggedIn) {
    return (
      <div className="pv2 ph2">
        <UserHeaderLoggedInDropdown
          currentUser={currentUser}
          totalNotificationsCount={notificationCounts.totalNotificationsCount}
          handleLogout={async () => {
            await currentUser.logout();
            window.location.reload();
          }}
        />
      </div>
    );
  }

  return <StripeChargeLoginButton onSuccessfulLogin={handleSuccessfulLogin} />;
}
